import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import WarehouseAllocationForm from "./warehouseAllocationComponents/WarehouseAllocationForm";

import {
  useGetWarehouseAllocationDetailQuery,
  useUpdateWarehouseAllocationMutation,
} from "store/services/warehouseAllocationApi";

import { useAppMeta } from "hooks";

const WarehouseAllocationEditScreen = () => {
  const { id } = useParams(); // Get allocation ID from the URL parameters
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Warehouse Allocations", path: "/app/crm/warehouse-allocation/list" },
    { title: "Edit Allocation" },
  ];

  // RTK Query
  const {
    data: allocationDetail,
    isLoading: loadingAllocation,
    error,
  } = useGetWarehouseAllocationDetailQuery(id); // Fetch allocation details using the ID

  const [updateWarehouseAllocation, { isLoading: updatingAllocation }] =
    useUpdateWarehouseAllocationMutation(); // Mutation to update allocation details

  // Update handler
  const handleUpdateAllocation = async (data) => {
    const payload = { id, ...data };

    try {
      await updateWarehouseAllocation(payload).unwrap();
      toast.success("Warehouse allocation successfully updated!");
      navigate(`/app/crm/warehouse-allocation/${id}/detail`); // Redirect to allocation detail page
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update allocation!"
      );
    }
  };

  useAppMeta("Edit Warehouse Allocation");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingAllocation || updatingAllocation}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <WarehouseAllocationForm
          isBusy={loadingAllocation || updatingAllocation}
          allocationDetail={allocationDetail} // Pass the fetched allocation details to the form
          onSubmit={handleUpdateAllocation}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default WarehouseAllocationEditScreen;
